/**
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import { FormatLocaleDefinition } from 'd3-format';

// export const DEFAULT_D3_FORMAT: FormatLocaleDefinition = {
//   decimal: '.',
//   thousands: ',',
//   grouping: [3],
//   currency: ['$', ''],
// };

export const DEFAULT_D3_FORMAT: FormatLocaleDefinition = {
  decimal: '.', // 小数点符号
  thousands: ',', // 千位分隔符
  grouping: [3], // 分组大小数组
  currency: ['$', ''], // 默认使用美元符号，人民币使用 yuan_2 格式化器
};
